var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFirstResponsiveDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 6v52a1 1 0 0 0 1 1h52a1 1 0 0 0 1-1v-52a1 1 0 0 0 -1-1h-52a1 1 0 0 0 -1 1zm2 1h50v50h-50z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1 28h2v2h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1 24h2v2h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1 20h2v2h-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m1 16h2v2h-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m1 12h2v2h-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m1 8h2v2h-2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m28 1h2v2h-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m24 1h2v2h-2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m20 1h2v2h-2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m16 1h2v2h-2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m12 1h2v2h-2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m8 1h2v2h-2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m3 3h3v-2h-4a1 1 0 0 0 -1 1v4h2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m34 61h2v2h-2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m38 61h2v2h-2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m42 61h2v2h-2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m46 61h2v2h-2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m50 61h2v2h-2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m54 61h2v2h-2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m61 33.999h2v2h-2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m61 37.999h2v2h-2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m61 41.999h2v2h-2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m61 45.999h2v2h-2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m61 49.999h2v2h-2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m61 53.999h2v2h-2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m61 61h-3v2h4a1 1 0 0 0 1-1v-4h-2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m62 1h-30v2h29v29h2v-30a1 1 0 0 0 -1-1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m2 63h30v-2h-29v-29h-2v30a1 1 0 0 0 1 1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m40 11a8.955 8.955 0 0 0 -5.644 2h-12.356a5.006 5.006 0 0 0 -5 5v30a5.006 5.006 0 0 0 5 5h16a5.006 5.006 0 0 0 5-5v-19.525a8.994 8.994 0 0 0 -3-17.475zm-18 4h10.522a9 9 0 0 0 -1 2h-12.338a3 3 0 0 1 2.816-2zm16 36h-16a3 3 0 0 1 -3-3v-3h22v3a3 3 0 0 1 -3 3zm3-8h-22v-24h12.059a8.972 8.972 0 0 0 9.941 9.941zm-1-16a7 7 0 1 1 7-7 7.008 7.008 0 0 1 -7 7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m40.472 15.118a1 1 0 0 0 -1.027.05l-3 2 1.11 1.664 1.445-.963v7.131h2v-9a1 1 0 0 0 -.528-.882z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m28 47h4v2h-4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFirstResponsiveDesign);
export default __webpack_public_path__ + "static/media/Mobile-First, Responsive Design.516e17e76383b3bafe0fa4c1fce158d3.svg";
export { ForwardRef as ReactComponent };